import { render, staticRenderFns } from "./Return.vue?vue&type=template&id=62fdef64&scoped=true&"
import script from "./Return.vue?vue&type=script&lang=js&"
export * from "./Return.vue?vue&type=script&lang=js&"
import style0 from "./Return.vue?vue&type=style&index=0&id=62fdef64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fdef64",
  null
  
)

/* custom blocks */
import block0 from "./Return.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports